import { techDocs } from "../technical-docs";

export default techDocs('cte_rcdi_enredes', 'CTE-RCDI-ENREDES', 'documentos-tecnicos-cte-rcdi-enredes')